import { useTransportationAggregateTypeFilter } from '@/audit-log/_state/transportationEvents.state';

export const TransportationEntityFilter = () => {
  const [aggregateType] = useTransportationAggregateTypeFilter();

  if (!aggregateType) return null;

  return null;
};
